import classNames from "classnames";
import {
    Form1099Box,
    getForm1099BoxLabel,
} from "@common/constants/domains/accounting/form1099Box";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { Picker } from "@design-system/Picker/Picker.lib";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import {
    FORM_1099_BOX_PICKER_ITEMS,
    toForm1099Box,
} from "./form1099BoxCellHelpers";
import styles from "./Form1099BoxCell.module.scss";

interface Form1099BoxPickerProps {
    value: Form1099Box | null;
    isDisabled: boolean;
    disabledTooltip?: string;
    onChange: (nextBox: Form1099Box | null) => void;
}

export const Form1099BoxPicker = ({
    value,
    isDisabled,
    disabledTooltip,
    onChange,
}: Form1099BoxPickerProps) => {
    const selectedLabel = getForm1099BoxLabel(value) ?? undefined;

    return (
        <span
            className={classNames(styles.triggerWrapper, {
                [viewTableStyles.showOnHover]: !selectedLabel,
                [viewTableStyles.forceShow]: !!selectedLabel,
            })}
        >
            <Picker.Select
                items={FORM_1099_BOX_PICKER_ITEMS}
                nested="flyout"
                trigger="cell"
                value={value}
                onValueChange={(nextValue) => {
                    const nextBox = toForm1099Box(nextValue);
                    if (nextBox !== undefined) {
                        onChange(nextBox);
                    }
                }}
                renderValue={() => selectedLabel}
                placeholder="Select box"
                disabled={isDisabled}
                className={styles.cellTrigger}
                buttonProps={{
                    disabled: isDisabled,
                    tooltip: disabledTooltip,
                }}
            />
        </span>
    );
};

export const Form1099BoxReadOnlyCell = ({
    value,
}: {
    value: Form1099Box | null | undefined;
}) => {
    const label = getForm1099BoxLabel(value);

    return (
        <ViewTableCell>
            {label ? (
                <span className={styles.cellTrigger}>{label}</span>
            ) : (
                <EmptyValue />
            )}
        </ViewTableCell>
    );
};
